import Vue from 'vue'
import VueRouter from 'vue-router'

const MainLayout = () => import('@/layout/Main')
const Utama = () => import('@/views/Utama')
const DetailCourse = () => import('@/views/DetailCourse')
const Temukan = () => import('@/views/Temukan')
const Auth = () => import('@/views/Auth')
const Masuk = () => import('@/components/App/Auth/MasukForm')
const Daftar = () => import('@/components/App/Auth/DaftarForm')
const LupaSandi = () => import('@/components/App/Auth/LupaSandiForm')
const Keranjang = () => import('@/views/Keranjang')
const CourseSaya = () => import('@/views/CourseSaya')
const WishlistSaya = () => import('@/views/WishlistSaya')
const DetailCourseSaya = () => import('@/views/CourseSaya/Detail')
const Bantuan = () => import('@/views/Bantuan')
const KetentuanPenggunaan = () => import('@/views/Legal/KetentuanPenggunaan')
const KebijakanPrivasi = () => import('@/views/Legal/KebijakanPrivasi')
const Akun = () => import('@/views/Akun')
const NotFound = () => import('@/views/404')
const PaymentSuccess = () => import('@/views/PaymentSuccess')
const SuccessVerify = () => import('@/views/SuccessVerify')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'Main',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Utama',
        component: Utama,
        meta: { authRequired: false },
      },
      {
        path: '/course/:id',
        name: 'Detail Course',
        component: DetailCourse,
        meta: { authRequired: false },
      },
      {
        path: '/cari',
        name: 'Temukan',
        component: Temukan,
        meta: { authRequired: false },
      },
      {
        path: '/wishlist-saya',
        name: 'Wishlist Saya',
        component: WishlistSaya,
        meta: { authRequired: true },
      },
      {
        path: '/course-saya',
        name: 'Course Saya',
        component: CourseSaya,
        meta: { authRequired: true },
      },
      {
        path: '/keranjang',
        name: 'Keranjang',
        component: Keranjang,
        meta: { authRequired: false },
      },
      {
        path: '/bantuan',
        name: 'Bantuan',
        component: Bantuan,
        meta: { authRequired: false },
      },
      {
        path: '/ketentuan-penggunaan',
        name: 'Ketentuan Penggunaan',
        component: KetentuanPenggunaan,
        meta: { authRequired: false },
      },
      {
        path: '/kebijakan-privasi',
        name: 'Kebijakan Privasi',
        component: KebijakanPrivasi,
        meta: { authRequired: false },
      },
      {
        path: '/course-saya/:id',
        name: 'Detail Course Saya',
        component: DetailCourseSaya,
        meta: { authRequired: true },
      },
      {
        path: '/akun',
        name: 'Akun',
        component: Akun,
        meta: { authRequired: true },
      },
    ],
  },
  {
    path: '/',
    meta: { authRequired: false, isAuth: true },
    component: Auth,
    children: [
      {
        path: '/masuk',
        name: 'Masuk',
        component: Masuk,
      },
      {
        path: '/daftar',
        name: 'Daftar',
        component: Daftar,
      },
      {
        path: '/lupa-sandi',
        name: 'Lupa Sandi',
        component: LupaSandi,
      },
    ],
  },
  {
    path: '/success-verify',
    name: 'Success Verify',
    component: SuccessVerify,
  },
  {
    path: '/success-payment',
    name: 'Payment Success',
    component: PaymentSuccess,
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
      // Or for Vue 3:
      // return {el: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = `${to.name} | ${process.env.VUE_APP_TITLE}`
  const sessionId = Vue.$cookies.get('sessionId')
  // console.log(to, from)
  // if (to.name === 'Temukan' && from.name === 'Temukan') next({ name: 'Temukan', query: { ...to.query } })
  if (to.matched.some(record => record.meta.authRequired)) {
    // console.log(to.name, 'masuk 1')
    if (!sessionId) next({ name: 'Masuk', query: { redirect: to.path } })
    else next()
    // console.log(to.name, 'masuk 2')
  } else {
    if (to.matched.some(record => record.meta.isAuth) && sessionId) { next({ name: 'Utama' }) }
    next()
  }
})

export default router
